import styled, { css } from 'styled-components';

import React, { useState } from 'react';

import { X, VideoBackGround } from '../../Constants/assets';

const InfoInnerContainer = styled.div`
    width: 70%;
    min-height: 540px;
    background: ${props => props.theme.colors.white};
    box-shadow: 0px 0px 24px rgba(0, 0, 0, 0.18);
    border-radius: 8px;
    text-align: center;
    font-family: 'Roboto', sans-serif;
    z-index: 100;
    height: fit-content;
    position: absolute;
`;
const BodyContainer = styled.div`
    width: 94%;
    height: 90%;
    margin: 0 auto;
    justify-content: center;
`;

const HeaderContainer = styled.div`
    display: flex;
    margin 35px auto;
    justify-content: space-between;
    ${css`
        @media (max-height: 730px) {
            /* CSS styles for screens with a height less than 730px */
            margin-bottom: 0;
        }
    `}
`;
const Title = styled.div`
    font-weight: bold;
    font-size: 24px;
`;
const XContainer = styled.div``;
const ParagraphContainer = styled.div`
    width: 50%;
    text-align: -webkit-left;
    line-height: 20px;
    font-size: 16px;
    margin-bottom: 40px;
    @media (max-width: 1400px) {
        font-size: 14px;
    }
`;
const VideoContainer = styled.div`
    width: 50%;
`;

const TutorialDiv = styled.div`
    padding: 56.25% 0 0 0;
    ${'' /* position: relative; */}
`;

export default function Tutorial({ title, paragraph, toggleTutorial, tutorialShow, styling }) {
    const [stageTutorial, setStageTutorial] = useState(0);
    if (tutorialShow == false) return null;
    if (stageTutorial === 0) {
        return (
            <InfoInnerContainer>
                <BodyContainer>
                    <HeaderContainer>
                        <Title>{title}</Title>
                        <XContainer onClick={() => toggleTutorial(false)}>
                            <X style={{ cursor: 'pointer' }} />
                        </XContainer>
                    </HeaderContainer>
                    <div style={{ display: 'flex' }}>
                        <ParagraphContainer>
                            <p>
                                You have been assigned to lead a project in the PMzone digital
                                simulation board game. Your mission is to complete your project's
                                scope and achieve its goals.
                            </p>
                            <br />
                            <p>
                                During play, you will need to add value to your project, plan your
                                progress, perform both known and unforeseen tasks, deal with
                                constraints and risks, operate within budget and resource
                                constraints, see the big picture, be in control of the details,
                                manage uncertainty, and remain on target.
                            </p>
                            <br />
                            <p>
                                At the end of the game, you will receive a detailed report with your
                                game data, so that you can reflect on and improve your next game.
                            </p>
                            <br />
                            <p>
                                The game starts by planning the order for executing the known tasks
                                included in your project. The order of execution should take into
                                account the task data (cost, resources, value and progress on the
                                board), the availability of budget and resources (during planning
                                and later in the game), the game board layout and your project
                                goals.
                            </p>
                            <br />
                            <b>
                                Pay attention to the value of your project as it will be checked at
                                every gate you reach. If it's too low, your project may be canceled!
                            </b>
                        </ParagraphContainer>
                        <VideoContainer>
                            <iframe
                                src="https://player.vimeo.com/video/671696142?h=0bdc37885e&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                                frameBorder="0"
                                width="88%"
                                height="256px"
                                allow="autoplay; fullscreen; picture-in-picture"
                                // allowfullscreenstyle="position:absolute;top:0;left:0;width:100%;height:100%;" // keep allowfullscreenstyle lower case
                                title="Tutorial"
                            />
                            <script src="https://player.vimeo.com/api/player.js" />
                        </VideoContainer>
                    </div>
                </BodyContainer>
            </InfoInnerContainer>
        );
    }
}
